<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">
          공모전
        </div>
        <div>
          <competition-list-component :competitionType="`competition`"></competition-list-component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CompetitionListComponent from "@/components/competition/CompetitionListComponent";

export default {
  name: "Competition",
  mixins: [],
  components: {
    CompetitionListComponent
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{

    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{

  },
  watch: {

  },
}
</script>

<style scoped>

</style>